import React from 'react';
import { Img, Txt } from "Components/GenericView";
import { SMILEY_CP_DETAILS } from "Constants";

export type SelectedCareProsPropType = {
  isReadOnly: boolean | undefined;
  assignedCarepros: Array<object>;
}

const SelectedCarePros = (props: SelectedCareProsPropType) => {
  const { isReadOnly, assignedCarepros } = props;

  if (isReadOnly) {
    return <>
      <div className="nvd-row h">
        <Img src="/carepro.png" className="nvd-icon" />
        <div className="h grow">
          <Txt
            className="nvd-text no-shrink"
            width={100}
            mr={-10}
            mt={4}
          >
            CP(s)
          </Txt>
          <div className="nvd-cont v">
            <div className="h wrap">
              {assignedCarepros.map((cp: any) => {
                const profile = (cp && cp.profile) || {
                  first_name: "Not",
                  last_name: "Assigned",
                };
                const id = cp._id,
                  name =
                    (cp.role === "Doctor" ? "Dr. " : "") +
                    profile.first_name +
                    " " +
                    profile.last_name;
                return (
                  <div
                    className="chip chip-big nvd-cp-chip"
                    key={id || "1"}
                    have-link={id}
                    onClick={() =>
                      id && window.open(SMILEY_CP_DETAILS + id)
                    }
                  >
                    <img
                      src={profile.avatar_url || "/carepro.png"}
                      alt={name}
                      className="nvd-cp"
                    />
                    {name}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  }

  return null;
}

export default SelectedCarePros;